export default __webpack_public_path__ + "static/media/leslie.a161b53f.jpg";